import { ChangeDetectorRef, Component, OnInit, ViewChildren, QueryList, ViewChild, ElementRef, inject, TemplateRef, AfterViewInit } from '@angular/core';
import { AdminService } from 'src/services/admin.service';
import { ConfigService } from 'src/services/config.service';
import { StudyStatusModel, studyModel } from 'src/models/study.model';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { participantModel } from 'src/models/participant.model';
import { ParticipantService } from 'src/services/participant.service';
import { filterPrescreened, studyFilter } from 'src/app/model/gridFilter.model';
import { DataService } from 'src/services/data.service';
import { MultiSelect } from 'primeng/multiselect';
import { NavigationTrackingService } from 'src/services/navigation-tracking.service';
import { ExcelExportService } from 'src/app/service/excel-export.service';
import { SelectItem } from 'primeng/api';
import { StudyStatus } from 'src/models/study.model';
import { ConfirmationService } from 'primeng/api';
import { UserAccessService, UserModel } from 'src/services/useraccess.service';
import { Role, Function, Access, Screen } from 'src/Utilities/enum';
import { UserPreferencesStore } from 'src/app/store/user-preferences/user-preferences.store';
import { NavigationStore } from 'src/app/store/navigation/navigation.store';
import { AuthStore } from 'src/app/store/authorization/auth.store';
import { DatePipe } from '@angular/common';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';
import { DynamicColumnConfig, DynamicTableConfig, DynamicTableFilter, ExportEvent, SelectionEvent } from 'src/app/shared/dynamic-table/dynamic-table.model';
import { DynamicTableComponent } from 'src/app/shared/dynamic-table/dynamic-table.component';
import { DateHelper } from 'src/Utilities/utility';
import { configModel } from 'src/models/config.model';

@Component({
  selector: 'app-adminhome',
  templateUrl: './admin_home.component.html',
  styleUrls: ['./admin_home.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS, DynamicTableComponent]
})

export class AdminHomeComponent implements OnInit, AfterViewInit {
  @ViewChild('scrollTop', { static: true }) scrollTop: ElementRef;
  @ViewChild('dt', { static: true }) dt;
  @ViewChild(DynamicTableComponent) dynamicTable: DynamicTableComponent;
  @ViewChild('preQualifiedDynamicTable') preQualifiedDynamicTable: DynamicTableComponent;
  @ViewChild('actionsTemplate', { static: false }) actionsTemplate: TemplateRef<any>;
  @ViewChild('statusTemplate', { static: false }) statusTemplate: TemplateRef<any>;
  @ViewChild('exportTemplate', { static: false }) exportTemplate: TemplateRef<any>;
  @ViewChild('preQualifiedNameTemplate', { static: false }) preQualifiedNameTemplate: TemplateRef<any>;
  @ViewChildren('studyNumberClear') clearstudyNumber: QueryList<MultiSelect>;
  @ViewChildren('studyTagClear') clearTag: QueryList<MultiSelect>;
  @ViewChildren('studyStatusClear') clearStatus: QueryList<MultiSelect>;
  @ViewChildren('studyNameClear') clearStudy: QueryList<MultiSelect>;
  @ViewChildren('nameClear') clearName: QueryList<MultiSelect>;
  @ViewChildren('ageClear') clearage: QueryList<MultiSelect>;
  @ViewChildren('genderClear') cleargender: QueryList<MultiSelect>;
  @ViewChildren('dateCompletedClear') cleardateCompleted: QueryList<MultiSelect>;

  availablestudies: studyModel[] = [];
  selectedStudies: studyModel[] = [];
  deleteModel: studyModel;
  validity: boolean;
  userId: string;
  cols: any[];
  dynamicColumns: DynamicColumnConfig[] = [];
  tableConfig: DynamicTableConfig = {};
  studyCellTemplates: { [field: string]: TemplateRef<any> } = {};
  tags: SelectItem[] = [];
  studyName_studyGrid: SelectItem[] = [];
  status: SelectItem[] = [
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Active', value: 'Active' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Archive', value: 'Archive' }
  ];
  aa: SelectItem;
  cols_prescreened: any[];
  preQualifiedDynamicColumns: DynamicColumnConfig[] = [];
  preQualifiedTableConfig: DynamicTableConfig = {};
  preQualifiedCellTemplates: { [field: string]: TemplateRef<any> } = {};
  studynumber: SelectItem[] = [];
  age: SelectItem[] = [];
  gender: SelectItem[] = [];
  dateCompleted: SelectItem[] = [];
  participantlist: participantModel[];
  filteredParticipantlist: participantModel[];
  prescreenedFilter: filterPrescreened = new filterPrescreened();
  prescreenedFilterHier: string[] = [];
  filterAvailablestudies: studyModel[] = [];
  studyFilter: studyFilter = new studyFilter();
  studyFilterHier: string[] = [];
  selectedStudyNumber: string[] = [];
  selectedTag: string[] = [];
  selectedStatus: string[] = [];
  selectedStudyName: string[] = [];
  selectedAge: number[] = [];
  selectedGender: string[] = [];
  selectedDateCompleted: string[] = [];
  isFromSessionStore = false;
  isFirstVisit = false;
  datePipe: DatePipe = new DatePipe('en-US');
  checkedStudyNumber: string[] = [];
  checkedStudyTags: string[] = [];
  checkedStudyStatus: string[] = [];
  checkedStudyName: string[] = [];
  checkedAge: number[] = [];
  checkedGender: string[] = [];
  checkedDateCompleted: string[] = [];
  sessionStoreStudy: any;
  sessionStorePrescreened: any;
  isClearStudyFilterOn = false;
  isClearPrescreenedFilterOn = false;
  participantListForExport: any[] = [];
  preQualifiedListForExport: any[] = [];
  questionTextStudy: any[] = [];
  participantIdList: string;
  questionIdList: any[] = [];
  studyStatuses: StudyStatusModel[] = [];
  studyStatusType = StudyStatus;
  isDeleteEnabled = false;
  isDeleteApplied = false;
  PreQualifiedVisible: boolean = false;
  httpClientRequestTimeOut: string = '';
  public roleId: number;
  private readonly userPreferencesStore = inject(UserPreferencesStore);
  private readonly navigationStore = inject(NavigationStore);
  private readonly authStore = inject(AuthStore);

  private deferUiUpdate(updateFn: () => void): void {
    Promise.resolve().then(() => {
      updateFn();
      this.cdr.markForCheck();
    });
  }

  constructor(private studyService: AdminService, private confirmationService: ConfirmationService, private configService: ConfigService,
    private router: Router, private _route: ActivatedRoute, private participantService: ParticipantService, private dataService: DataService, private exportExcel: ExcelExportService, private userAccessService: UserAccessService,
    private cdr: ChangeDetectorRef) {
    this.availablestudies = _route.snapshot.data['studyList'];
    this.refreshAvailableStudies(this.availablestudies);
    this.isFirstVisit = this.navigationStore.isFirstNavigationToStudies();
    if (this.navigationStore.adminRefreshed()) {
      this.userPreferencesStore.resetAllFilters();
      this.navigationStore.setAdminRefreshed(false);
    }
  }
  displayNewStudyCall() {
    this.dataService.cleartData()
    this.router.navigate(['/adminhome/studydetail/'], { fragment: 'display', skipLocationChange: true });
  }
  displayCall(studyID) {
    this.router.navigate(['/adminhome/studydetail/', studyID], { fragment: 'display', skipLocationChange: true });
  }

  stratificationCall(studyID) {
    this.router.navigate(['/adminhome/studydetail/', studyID], { fragment: 'stratification', skipLocationChange: true });
  }

  questionCall(studyID) {
    this.router.navigate(['/adminhome/studydetail/', studyID], { fragment: 'question', skipLocationChange: true });
  }

  refreshAvailableStudies(availablestudies: studyModel[]) {
    if (availablestudies) {
      for (let key in availablestudies) {
        if (availablestudies.hasOwnProperty(key)) {
          if (availablestudies[key].studyTag && availablestudies[key].studyTag !== "") {
            availablestudies[key].tag = availablestudies[key].studyTag.split(',');
          }
          else {
            availablestudies[key].tag = [];
          }
        }
      }
      if (this.isDeleteApplied) {
        this.filterGridRecords_ClientSide(null, null, "studyNumber");
        this.filterGridRecords_ClientSide(null, null, "studyTag");
        this.filterGridRecords_ClientSide(null, null, "studyStatus");
        this.isDeleteApplied = false;
      } else {
        this.filterAvailablestudies = availablestudies.filter(x => x.StatusId === this.studyStatusType.Active).map(x => Object.assign({}, x));
      }
    }
  }

  get AddButtonVisible(): boolean {
    const isHaveAccessToDelete = this.authStore.getPermission(Screen.Study, Function.AddStudy);
    return isHaveAccessToDelete !== Access.NoAccess;
  }

  get DeleteButtonVisible(): boolean {
    const isHaveAccessToDelete = this.authStore.getPermission(Screen.Study, Function.DeleteStudy);
    return isHaveAccessToDelete !== Access.NoAccess;
  }

  ngOnInit() {
    this.fetchSessionStoreStudy();
    this.fetchSessionStorePrescreened();
    this.getPreScreenedApplicants();

    this.cols = [
      { field: 'studyName', header: 'Study Number', width: '215px' },
      { field: 'dir', header: '', width: '301px' },
      { field: 'studyTag', header: 'Tags', width: '325px' },
      { field: 'isPublished', header: 'Status', width: '150px' }
    ];

    this.tableConfig = {
      rows: 25,
      selectable: true,
      selectionMode: 'multiple',
      globalSearch: true,
      exportable: false,
      deletable: true,
      lazy: false,
      dataKey: 'studyId',
      columnFilteringEnabled: false,
      title: 'Studies',
      supportFilterHierarchy: true,
      addable: true,
      preferenceKey: 'studiesLibrary'
    };

    this.dynamicColumns = [
      {
        field: 'studyName',
        header: 'Study Number',
        width: '215px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'studyName',
        filterOptions: [],
        dataType: 'text'
      },
      {
        field: 'dir',
        header: '',
        width: '370px',
        sortable: false,
        filterable: false,
        customTemplate: 'actionsTemplate',
        dataType: 'text'
      },
      {
        field: 'studyTag',
        header: 'Tags',
        width: '300px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'studyTag',
        filterOptions: [],
        dataType: 'text'
      },
      {
        field: 'isPublished',
        header: 'Status',
        width: '170px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'isPublished',
        filterOptions: [],
        customTemplate: 'statusTemplate',
        dataType: 'text'
      },
      {
        field: 'export',
        header: '',
        width: '60px',
        sortable: false,
        filterable: false,
        customTemplate: 'exportTemplate',
        dataType: 'text'
      }
    ];

    this.cols_prescreened = [
      { field: 'name', header: 'Applicant Name', width: '250px' },
      { field: 'studyName', header: 'Study Number', width: '200px' },
      { field: 'age', header: 'Age', width: '125px' },
      { field: 'gender', header: 'Gender', width: '150px' },
      { field: 'createdDate', header: 'Date Completed', width: '215px' }
    ];

    this.preQualifiedTableConfig = {
      rows: 25,
      selectable: false,
      selectionMode: 'multiple',
      globalSearch: false,
      exportable: true,
      deletable: false,
      lazy: false,
      dataKey: 'participantId',
      preferenceKey: 'preQualifiedApplicants',
      columnFilteringEnabled: false,
      title: 'PreQualified Applicants',
      supportFilterHierarchy: true,
      addable: false,
      showPagination: true
    };

    this.preQualifiedDynamicColumns = [
      {
        field: 'name',
        header: 'Applicant Name',
        width: '250px',
        sortable: true,
        filterable: false,
        customTemplate: 'preQualifiedNameTemplate',
        dataType: 'text'
      },
      {
        field: 'studyName',
        header: 'Study Number',
        width: '200px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'studyName',
        filterOptions: [],
        dataType: 'text'
      },
      {
        field: 'age',
        header: 'Age',
        width: '125px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'age',
        filterOptions: [],
        dataType: 'number'
      },
      {
        field: 'gender',
        header: 'Gender',
        width: '150px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'gender',
        filterOptions: [],
        dataType: 'text'
      },
      {
        field: 'createdDate',
        header: 'Date Completed',
        width: '215px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'createdDate',
        filterOptions: [],
        dataType: 'text'
      }
    ];

    this.studyFilterHier.push('studyStatus');

    if (!this.isFromSessionStore)
      this.studyFilter.status = ['Active'];

    this.studyService.getAllStudyStatuses()
      .subscribe(_s => {
        this.studyStatuses = _s;
        this.filterStudies_ClientSide("");
        if (this.isFromSessionStore) {
          this.filterGridRecords_ClientSide(null, null, "studyNumber");
          this.filterGridRecords_ClientSide(null, null, "studyTag");
          this.filterGridRecords_ClientSide(null, null, "studyStatus");
        }
      });

    this.userAccessService.userAccessData$.subscribe((userAccessData: UserModel[] | null) => {
      if (userAccessData && userAccessData.length > 0) {
        this.roleId = userAccessData[0].RoleId;
      }
    });
    this.PreQualifiedVisible = !(this.roleId == Role.Recruiter || this.roleId == Role.RecruiterAssociate);

    this.configService.isConfigLoaded().subscribe(loaded => {
      if (loaded) {       
        let configModel = this.configService.getConfigModel();
        this.httpClientRequestTimeOut = configModel.getConfigkeyname('HttpClientRequestTimeOut');        
      }
    });
    
  }

  ngAfterViewInit() {
    if (this.actionsTemplate) this.studyCellTemplates['actionsTemplate'] = this.actionsTemplate;
    if (this.statusTemplate) this.studyCellTemplates['statusTemplate'] = this.statusTemplate;
    if (this.exportTemplate) this.studyCellTemplates['exportTemplate'] = this.exportTemplate;
    if (this.preQualifiedNameTemplate) this.preQualifiedCellTemplates['preQualifiedNameTemplate'] = this.preQualifiedNameTemplate;
  }

  onDynamicFilterChange(event: DynamicTableFilter) {
    const filters = event.columnFilters || {};
    const searchTerm = (event.searchTerm || '').toString().trim().toLowerCase();
    this.studyFilter.studyNumber = filters['studyName'] || [];
    this.studyFilter.tag = filters['studyTag'] || [];
    this.studyFilter.status = filters['isPublished'] || [];
    this.studyFilterHier = event.filterHierarchy || [];
    this.filterAvailablestudies = this.availablestudies.map(x => Object.assign({}, x));
    if (this.studyFilter.studyNumber.length > 0) {
      this.filterAvailablestudies = this.filterAvailablestudies.filter(x => this.studyFilter.studyNumber.includes(x.studyName));
    }
    if (this.studyFilter.tag.length > 0) {
      this.filterAvailablestudies = this.filterAvailablestudies.filter(data =>
        data.tag.findIndex(ta => this.studyFilter.tag.findIndex(m => m === ta) > -1) > -1
      );
    }
    if (this.studyFilter.status.length > 0) {
      this.filterAvailablestudies = this.filterAvailablestudies.filter(x => {
        const statusName = this.getStatusName(x.StatusId);
        return statusName !== null && this.studyFilter.status.includes(statusName);
      });
    }

    if (searchTerm.length > 0) {
      this.filterAvailablestudies = this.filterAvailablestudies.filter(study => {
        const studyNumber = (study.studyName || '').toLowerCase();
        const tags = (study.studyTag || '').toLowerCase();
        const statusName = (this.getStatusName(study.StatusId) || '').toLowerCase();
        return studyNumber.includes(searchTerm) || tags.includes(searchTerm) || statusName.includes(searchTerm);
      });
    }

    this.userPreferencesStore.setStudiesLibraryFilter(this.studyFilter);
    this.filterStudies_ClientSide('');
  }

  onDynamicSelectionChange(event: SelectionEvent) {
    this.selectedStudies = event.selectedRows || [];
    this.deferUiUpdate(() => {
      this.isDeleteEnabled = this.selectedStudies.some(s => s.StatusId === this.studyStatusType.Archive);
    });
  }

  onDynamicPageChange(event: any) {
    this.paginate(event);
  }

  onDynamicDelete(selectedRows: studyModel[]): void {
    this.selectedStudies = selectedRows || [];
    const hasArchivedSelection = this.selectedStudies.some(study => study.StatusId === StudyStatus.Archive);

    this.deferUiUpdate(() => {
      this.isDeleteEnabled = hasArchivedSelection;
    });

    if (!hasArchivedSelection) {
      return;
    }

    this.deleteSelectedStudies();
  }

  disableStudySelection = (row: studyModel): boolean => {
    return row?.StatusId !== StudyStatus.Archive;
  }

  onPreQualifiedDynamicFilterChange(event: DynamicTableFilter): void {
    this.isFromSessionStore = false;

    if (this.preQualifiedDynamicTable?.table) {
      this.preQualifiedDynamicTable.table.first = 0;
    }

    const filters = event.columnFilters || {};
    this.prescreenedFilterHier = event.filterHierarchy || [];

    this.prescreenedFilter.studyNumber = this.isPreQualifiedColumnExplicitlyFiltered('studyName')
      ? (filters['studyName'] || [])
      : [];
    this.prescreenedFilter.age = this.isPreQualifiedColumnExplicitlyFiltered('age')
      ? (filters['age'] || [])
      : [];
    this.prescreenedFilter.gender = this.isPreQualifiedColumnExplicitlyFiltered('gender')
      ? (filters['gender'] || [])
      : [];
    this.prescreenedFilter.dateCreated = this.isPreQualifiedColumnExplicitlyFiltered('createdDate')
      ? (filters['createdDate'] || [])
      : [];

    if (this.prescreenedFilter.age.includes(0) && !this.prescreenedFilter.age.includes(null)) {
      this.prescreenedFilter.age.push(null);
    }

    this.userPreferencesStore.setPreScreenedLibraryFilter(this.prescreenedFilter);
    this.participantService.getPrescreenedApplicants(this.prescreenedFilter)
      .subscribe(response => {
        this.participantlist = response;
        this.filteredParticipantlist = response;

        this.deferUiUpdate(() => {
          if (this.preQualifiedDynamicTable?.table) {
            this.preQualifiedDynamicTable.table.first = 0;
          }
        });

        const changedField = this.prescreenedFilterHier.length > 0
          ? this.prescreenedFilterHier[this.prescreenedFilterHier.length - 1]
          : '';
        this.getFilters(changedField, 'ok');
      });
  }

  onPreQualifiedDynamicPageChange(event: any): void {
    this.paginate(event);
  }

  onPreQualifiedDynamicExport(event: ExportEvent): void {
    this.exportAsXLSX();
  }

  fetchSessionStoreStudy() {
    const storedFilter = this.userPreferencesStore.studiesLibrary();
    if (storedFilter && (storedFilter.studyNumber.length > 0 || storedFilter.tag.length > 0 || storedFilter.status.length > 0)) {
      this.studyFilter = storedFilter;
      this.isFromSessionStore = true;
      this.selectedStudyNumber = this.studyFilter.studyNumber;
      this.selectedTag = this.studyFilter.tag;
      this.selectedStatus = this.studyFilter.status;
    }
  }

  fetchSessionStorePrescreened() {
    const storedFilter = this.userPreferencesStore.preScreenedLibrary();
    const hasActiveFilters = storedFilter && (
      storedFilter.studyNumber.length > 0 ||
      storedFilter.age.length > 0 ||
      storedFilter.gender.length > 0 ||
      storedFilter.dateCreated.length > 0
    );

    if (hasActiveFilters) {
      this.prescreenedFilter = storedFilter;
      this.isFromSessionStore = true;
      this.selectedStudyName = this.prescreenedFilter.studyNumber;
      this.selectedAge = this.prescreenedFilter.age;
      this.selectedGender = this.prescreenedFilter.gender;
      this.selectedDateCompleted = this.prescreenedFilter.dateCreated;
    }
  }

  getAvailableStudies() {
    this.studyService.getAllStudies()
      .subscribe(_s => {
        this.availablestudies = _s;
        this.refreshAvailableStudies(this.availablestudies);
      });
  }
  getStudyStatuses() {
    this.studyService.getAllStudyStatuses()
      .subscribe(_s => this.studyStatuses = _s);
  }

  private getStatusName(statusId: number): string | null {
    return this.studyStatuses.find(s => s.Id === statusId)?.StatusName ?? null;
  }

  deleteStudy(Id: number) {
    if (confirm("Are you sure you want to Delete the Study")) {
      this.studyService.deleteStudy(Id)
        .subscribe(res => {
          alert("Study Deleted Successfully");
          this.getAvailableStudies();
        });
    };
  }

  clearGridColumn_ClientSide(event, table, colname) {
    this.isClearStudyFilterOn = true;
    switch (colname) {
      case "studyNumber":
        this.studyFilter.studyNumber = [];
        this.clearstudyNumber.forEach(ds => {
          ds.value = null;
        });
        this.checkedStudyNumber = [];
        break;
      case "studyTag":
        this.studyFilter.tag = [];
        this.clearTag.forEach(ds => {
          ds.value = null;
        });
        this.checkedStudyTags = [];
        break;
      case "studyStatus":
        this.studyFilter.status = [];
        this.clearStatus.forEach(ds => {
          ds.value = null;
        });
        this.checkedStudyStatus = [];
        break;
    }
    this.prescreenedFilterHier = this.prescreenedFilterHier.filter(x => x !== colname);
    this.clearPrescreenFilter_ClientSide(colname);
  }

  filterGridRecords_ClientSide(event, table, colname) {
    this.filterAvailablestudies = this.availablestudies.map(x => Object.assign({}, x));

    if (!this.studyFilterHier.includes(colname))
      this.studyFilterHier.push(colname);
    if (event !== null) {
      switch (colname) {
        case "studyNumber":
          this.clearstudyNumber.forEach(ds => {
            if (ds.value !== null && ds.value !== undefined) {
              this.studyFilter.studyNumber = ds.value;

              if (this.studyFilter.studyNumber.length !== 0) {
                this.filterAvailablestudies = this.filterAvailablestudies
                  .filter(x => this.studyFilter.studyNumber.includes(x.studyName));
              }
            }
            ds.overlayVisible = false;
          });
          break;
        case "studyTag":
          this.clearTag.forEach(ds => {
            if (ds.value !== null && ds.value !== undefined) {
              this.studyFilter.tag = ds.value;
              this.filterAvailablestudies = this.filterAvailablestudies.filter(data => {
                return data.tag.findIndex(ta =>
                  this.studyFilter.tag.findIndex(m => m === ta) > -1) > -1
              });
            }
            ds.overlayVisible = false;
          });
          break;
        case "studyStatus":
          this.clearStatus.forEach(ds => {
            if (ds.value !== null && ds.value !== undefined) {
              this.studyFilter.status = ds.value;
              this.filterAvailablestudies = this.availablestudies.filter(x => {
                const statusName = this.getStatusName(x.StatusId);
                return statusName !== null && this.studyFilter.status.includes(statusName);
              });
            }
            ds.overlayVisible = false;
          });
          break;
      }
    }

    if (this.studyFilter.studyNumber.length !== 0) {
      this.filterAvailablestudies = this.filterAvailablestudies
        .filter(x => this.studyFilter.studyNumber.includes(x.studyName));
    }

    if (this.studyFilter.tag.length !== 0) {
      this.filterAvailablestudies = this.filterAvailablestudies.filter(data => {
        return data.tag.findIndex(ta =>
          this.studyFilter.tag.findIndex(m => m === ta) > -1) > -1
      });
    }

    if (this.studyFilter.status.length !== 0) {
      this.filterAvailablestudies = this.filterAvailablestudies
        .filter(x => {
          const statusName = this.getStatusName(x.StatusId);
          return statusName !== null && this.studyFilter.status.includes(statusName);
        });
    }

    this.userPreferencesStore.setStudiesLibraryFilter(this.studyFilter);
    this.selectedStudyNumber = this.studyFilter.studyNumber;
    this.selectedTag = this.studyFilter.tag;
    this.selectedStatus = this.studyFilter.status;
    this.filterStudies_ClientSide(colname);
  }
  clearPrescreenFilter_ClientSide(colname) {
    this.filterAvailablestudies = this.availablestudies.map(x => Object.assign({}, x));

    if (this.studyFilter.studyNumber.length !== 0) {
      this.filterAvailablestudies = this.filterAvailablestudies
        .filter(x => this.studyFilter.studyNumber.includes(x.studyName));
    }
    if (this.studyFilter.tag.length !== 0) {
      this.filterAvailablestudies = this.filterAvailablestudies.filter(data => {
        return data.tag.findIndex(ta =>
          this.studyFilter.tag.findIndex(m => m === ta) > -1) > -1
      });
    }
    if (this.studyFilter.status.length !== 0) {
      this.filterAvailablestudies = this.filterAvailablestudies
        .filter(x => {
          const statusName = this.getStatusName(x.StatusId);
          return statusName !== null && this.studyFilter.status.includes(statusName);
        });
    }
    this.filterStudies_ClientSide(colname);
    this.userPreferencesStore.setStudiesLibraryFilter(this.studyFilter);
  }

  filterStudies_ClientSide(filterFor) {
    if (this.studyFilter.studyNumber.length === 0)
      this.studyName_studyGrid = [];
    if (this.studyFilter.tag.length === 0)
      this.tags = [];
    if (this.studyFilter.status.length === 0)
      this.status = [];

    let _filteredStudylist = this.filterAvailablestudies.map(x => Object.assign({}, x));
    let tagArray = [];

    for (let key in _filteredStudylist) {
      if (_filteredStudylist.hasOwnProperty(key)) {
        tagArray.push(_filteredStudylist[key].studyTag);

        this.studyName_studyGrid.push({ label: _filteredStudylist[key].studyName, value: _filteredStudylist[key].studyName })
        if (_filteredStudylist[key].studyTag !== null) {
          _filteredStudylist[key].tag = _filteredStudylist[key].studyTag.split(',');
          if (_filteredStudylist[key].studyTag.split(',').length >= 1) {
            for (let k = 0; k < _filteredStudylist[key].studyTag.split(',').length; k++) {
              this.tags.push({ label: _filteredStudylist[key].studyTag.split(',')[k], value: _filteredStudylist[key].studyTag.split(',')[k] });
            }
          }
          else {
            this.tags.push({ label: _filteredStudylist[key].studyTag, value: _filteredStudylist[key].studyTag });
          }
        }
      }
    }

    this.studyName_studyGrid = Array.from(this.studyName_studyGrid.reduce((m, t) => m.set(t.label, t), new Map()).values());
    this.tags = Array.from(this.tags.reduce((m, t) => m.set(t.label, t), new Map()).values());

    this.studyName_studyGrid = this.studyName_studyGrid.sort((a, b) => a.label.localeCompare(b.label));
    this.tags = this.tags.sort((a, b) => a.label.localeCompare(b.label));

    if (this.studyFilterHier.length > 0) {
      if (this.studyFilterHier[0] === "studyNumber") {
        this.studyName_studyGrid = [];
      }
      else if (this.studyFilterHier[0] === "studyTag") {
        this.tags = [];
      }
      else if (this.studyFilterHier[0] === "studyStatus") {
        this.status = [];
      }

      for (let key in this.availablestudies) {
        if (this.availablestudies.hasOwnProperty(key)) {
          if (this.studyFilterHier[0] === "studyNumber") {
            if (this.availablestudies[key].studyName !== null && this.availablestudies[key].studyName.toString() !== "")
              this.studyName_studyGrid.push({ label: this.availablestudies[key].studyName, value: this.availablestudies[key].studyName });
          }
          else if (this.studyFilterHier[0] === "studyTag") {
            this.availablestudies[key].studyTag = this.availablestudies[key].studyTag === null ? "" : this.availablestudies[key].studyTag;
            if (this.availablestudies[key].studyTag !== null) {
              this.availablestudies[key].tag = this.availablestudies[key].studyTag.split(',');
              if (this.availablestudies[key].studyTag.split(',').length >= 1) {
                for (let k = 0; k < this.availablestudies[key].studyTag.split(',').length; k++) {
                  this.tags.push({ label: this.availablestudies[key].studyTag.split(',')[k], value: this.availablestudies[key].studyTag.split(',')[k] });
                }
              }
              else {
                this.tags.push({ label: _filteredStudylist[key].studyTag, value: _filteredStudylist[key].studyTag });
              }
            }
          }
          else if (this.studyFilterHier[0] === "studyStatus") {
            this.availablestudies[key].isPublished = this.availablestudies[key].isPublished === null ? false : this.availablestudies[key].isPublished;
            const statusName = this.getStatusName(this.availablestudies[key].StatusId);
            if (statusName !== null) {
              this.status.push({
                label: statusName,
                value: statusName
              });
            }
          }
        }
      }
    }

    this.studyName_studyGrid = Array.from(this.studyName_studyGrid.reduce((m, t) => m.set(t.label, t), new Map()).values());
    this.tags = Array.from(this.tags.reduce((m, t) => m.set(t.label, t), new Map()).values());
    this.status = Array.from(this.status.reduce((m, t) => m.set(t.label, t), new Map()).values());

    this.studyName_studyGrid = this.studyName_studyGrid.sort((a, b) => a.label.localeCompare(b.label));
    this.tags = this.tags.sort((a, b) => a.label.localeCompare(b.label));
    this.status = this.status.sort((a, b) => a.value - b.value)

    if (!this.isClearStudyFilterOn) {
      Promise.resolve().then(() => {
        if (this.isFromSessionStore) {
          this.checkedStudyNumber = this.selectedStudyNumber;
          this.checkedStudyTags = this.selectedTag;
          this.checkedStudyStatus = this.selectedStatus;
        } else {
          if (this.isFirstVisit || this.sessionStoreStudy === null) {
            this.checkedStudyNumber = this.studyName_studyGrid.map(x => x.value);
            if (!this.checkedStudyTags || this.checkedStudyTags.length === 0) {
              this.checkedStudyTags = this.tags.map(x => x.value);
            }
            this.checkedStudyStatus = ['Active'];
          } else {
            this.checkedStudyNumber = this.studyFilter.studyNumber;
            this.checkedStudyTags = this.studyFilter.tag;
            this.checkedStudyStatus = this.studyFilter.status;
          }
        }
        this.isClearStudyFilterOn = false;
        this.cdr.markForCheck();
      });
    }

    // Sync filter options to dynamicColumns
    this.deferUiUpdate(() => {
      const studyNameCol = this.dynamicColumns.find(c => c.field === 'studyName');
      if (studyNameCol) studyNameCol.filterOptions = this.studyName_studyGrid.map(o => ({ label: o.label, value: o.value }));
      const studyTagCol = this.dynamicColumns.find(c => c.field === 'studyTag');
      if (studyTagCol) studyTagCol.filterOptions = this.tags.map(o => ({ label: o.label, value: o.value }));
      const statusCol = this.dynamicColumns.find(c => c.field === 'isPublished');
      if (statusCol) statusCol.filterOptions = this.status.map(o => ({ label: o.label, value: o.value }));
      this.dynamicColumns = [...this.dynamicColumns];
    });
  }

  /* Pre-Screened grid filter methods started */
  getFilters(colname, clickType) {
    if (this.prescreenedFilterHier.length > 0) {
      if (this.prescreenedFilterHier[0] == "studyName" && (colname !== "studyName" || clickType === "clear")) {
        this.deferUiUpdate(() => {
          this.studynumber = [];
        });
        let prescreenedFilterPrimary = new filterPrescreened();
        this.participantService.getPrescreenedStudynumberFilter(prescreenedFilterPrimary)
          .subscribe(response => {
            const studyNumbers = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                studyNumbers.push({ label: response[key].studyName, value: response[key].studyName })
              }
            }
            this.deferUiUpdate(() => {
              this.studynumber = studyNumbers;
              this.updatePreQualifiedDynamicFilterOptions();
            });
          });
      }
      else if (this.prescreenedFilterHier[0] === "age" && (colname !== "age" || clickType === "clear")) {
        this.deferUiUpdate(() => {
          this.age = [];
        });
        let prescreenedFilterPrimary = new filterPrescreened();

        this.participantService.getPrescreenedAgeFilter(prescreenedFilterPrimary)
          .subscribe(response => {
            let ageOptions = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                if (response[key].age !== null)
                  ageOptions.push({ label: response[key].age === -2 ? '0' : response[key].age.toString(), value: response[key].age === -2 ? 0 : response[key].age });
              }
            }
            ageOptions = Array.from(ageOptions.reduce((m, t) => m.set(t.label, t), new Map()).values());
            this.deferUiUpdate(() => {
              this.age = ageOptions;
              this.updatePreQualifiedDynamicFilterOptions();
            });
          });
      }
      else if (this.prescreenedFilterHier[0] === "gender" && (colname !== "gender" || clickType === "clear")) {
        this.gender = [];

        this.gender = [
          { label: 'Female', value: 'F' },
          { label: 'Male', value: 'M' }
        ];
        this.updatePreQualifiedDynamicFilterOptions();
      }
      else if (this.prescreenedFilterHier[0] === "createdDate" && (colname !== "createdDate" || clickType === "clear")) {
        this.status = [];
        let prescreenedFilterPrimary = new filterPrescreened();
        this.participantService.getPrescreenedDateCompletedFilter(prescreenedFilterPrimary)
          .subscribe(response => {
            this.dateCompleted = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                if (response[key].createdDate === null || response[key].createdDate === "") {
                  this.dateCompleted.push({ label: "(Blank)", value: null });
                }
                else {
                  this.dateCompleted.push({ label: this.datePipe.transform(response[key].createdDate, 'dd MMM yyyy'), value: this.datePipe.transform(response[key].createdDate, 'dd MMM yyyy') });
                }
              }
            }
            this.updatePreQualifiedDynamicFilterOptions();
          });
      }
      if (this.prescreenedFilter.age.includes(0) && !this.prescreenedFilter.age.includes(null))
        this.prescreenedFilter.age.push(null);

      if (this.prescreenedFilterHier[0] !== "age" && (colname !== "age" || clickType === "clear")) {
        this.participantService.getPrescreenedAgeFilter(this.prescreenedFilter)
          .subscribe(response => {
            let ageOptions = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                if (response[key].age !== null)
                  ageOptions.push({ label: response[key].age === -2 ? '0' : response[key].age.toString(), value: response[key].age === -2 ? 0 : response[key].age });
              }
            }
            ageOptions = Array.from(ageOptions.reduce((m, t) => m.set(t.label, t), new Map()).values());
            this.deferUiUpdate(() => {
              this.age = ageOptions;
              this.updatePreQualifiedDynamicFilterOptions();
            });
          });
      }
      if (this.prescreenedFilterHier[0] !== "gender" && (colname !== "gender" || clickType === "clear")) {
        this.gender = [
          { label: 'Female', value: 'F' },
          { label: 'Male', value: 'M' }
        ];
        this.updatePreQualifiedDynamicFilterOptions();
      }
      if (this.prescreenedFilterHier[0] !== "studyName" && (colname !== "studyName" || clickType === "clear")) {
        this.participantService.getPrescreenedStudynumberFilter(this.prescreenedFilter)
          .subscribe(response => {
            const studyNumbers = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                studyNumbers.push({ label: response[key].studyName, value: response[key].studyName })
              }
            }
            this.deferUiUpdate(() => {
              this.studynumber = studyNumbers;
              this.updatePreQualifiedDynamicFilterOptions();
            });
          });
      }
      if (this.prescreenedFilterHier[0] !== "createdDate" && (colname !== "createdDate" || clickType === "clear")) {
        this.participantService.getPrescreenedDateCompletedFilter(this.prescreenedFilter)
          .subscribe(response => {
            this.dateCompleted = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                if (response[key].createdDate === null || response[key].createdDate === "") {
                  this.dateCompleted.push({ label: "(Blank)", value: null });
                }
                else {
                  this.dateCompleted.push({ label: this.datePipe.transform(response[key].createdDate, 'dd MMM yyyy'), value: this.datePipe.transform(response[key].createdDate, 'dd MMM yyyy') });
                }
              }
            }
            this.updatePreQualifiedDynamicFilterOptions();
          });
      }
    }
    else {
      this.prescreenedFilter = new filterPrescreened();
      this.gender = [
        { label: "Female", value: "F" },
        { label: "Male", value: "M" }
      ];
      this.updatePreQualifiedDynamicFilterOptions();
      this.participantService.getPrescreenedAgeFilter(this.prescreenedFilter)
        .subscribe(response => {
          let ageOptions = [];
          for (let key in response) {
            if (response.hasOwnProperty(key)) {
              if (response[key].age !== null)
                ageOptions.push({ label: response[key].age === -2 ? '0' : response[key].age.toString(), value: response[key].age === -2 ? 0 : response[key].age });
            }
          }
          ageOptions = Array.from(ageOptions.reduce((m, t) => m.set(t.label, t), new Map()).values());
          this.deferUiUpdate(() => {
            this.age = ageOptions;
            this.updatePreQualifiedDynamicFilterOptions();
          });
        });
      this.participantService.getPrescreenedStudynumberFilter(this.prescreenedFilter)
        .subscribe(response => {
          const studyNumbers = [];
          for (let key in response) {
            if (response.hasOwnProperty(key)) {
              studyNumbers.push({ label: response[key].studyName, value: response[key].studyName })
            }
          }
          this.deferUiUpdate(() => {
            this.studynumber = studyNumbers;
            this.updatePreQualifiedDynamicFilterOptions();
          });
        });
      this.participantService.getPrescreenedDateCompletedFilter(this.prescreenedFilter)
        .subscribe(response => {
          this.dateCompleted = [];
          for (let key in response) {
            if (response.hasOwnProperty(key)) {
              if (response[key].createdDate === null || response[key].createdDate === "") {
                this.dateCompleted.push({ label: "(Blank)", value: null });
              }
              else {
                this.dateCompleted.push({ label: this.datePipe.transform(response[key].createdDate, 'dd MMM yyyy'), value: this.datePipe.transform(response[key].createdDate, 'dd MMM yyyy') });
              }
            }
          }
          this.updatePreQualifiedDynamicFilterOptions();
        });
    }
    this.updatePreQualifiedDynamicFilterOptions();
    this.filterApplicants(colname);
  }

  private updatePreQualifiedDynamicFilterOptions(): void {
    this.deferUiUpdate(() => {
      const studyNameCol = this.preQualifiedDynamicColumns.find(c => c.field === 'studyName');
      if (studyNameCol) {
        studyNameCol.filterOptions = this.studynumber.map(option => ({ label: option.label, value: option.value }));
      }

      const ageCol = this.preQualifiedDynamicColumns.find(c => c.field === 'age');
      if (ageCol) {
        ageCol.filterOptions = this.age.map(option => ({ label: option.label, value: option.value }));
      }

      const genderCol = this.preQualifiedDynamicColumns.find(c => c.field === 'gender');
      if (genderCol) {
        genderCol.filterOptions = this.gender.map(option => ({ label: option.label, value: option.value }));
      }

      const createdDateCol = this.preQualifiedDynamicColumns.find(c => c.field === 'createdDate');
      if (createdDateCol) {
        createdDateCol.filterOptions = this.dateCompleted.map(option => ({ label: option.label, value: option.value }));
      }

      this.preQualifiedDynamicColumns = [...this.preQualifiedDynamicColumns];
      this.syncPreQualifiedFilterCheckboxes();
    });
  }

  private isPreQualifiedColumnExplicitlyFiltered(field: string): boolean {
    return this.prescreenedFilterHier.includes(field);
  }

  private getPreQualifiedOptionValues(field: string): any[] {
    const column = this.preQualifiedDynamicColumns.find(c => c.field === field);
    return (column?.filterOptions || []).map(option => option.value);
  }

  private syncPreQualifiedFilterCheckboxes(): void {
    if (!this.preQualifiedDynamicTable) {
      return;
    }

    const filterFields = ['studyName', 'age', 'gender', 'createdDate'];

    filterFields.forEach(field => {
      const availableValues = this.getPreQualifiedOptionValues(field);
      const isExplicitlyFiltered = this.isPreQualifiedColumnExplicitlyFiltered(field);

      if (!isExplicitlyFiltered) {
        this.preQualifiedDynamicTable.checkedFilters[field] = [...availableValues];
        this.preQualifiedDynamicTable.selectedFilters[field] = [];
        this.preQualifiedDynamicTable.selectAllFilters[field] = availableValues.length > 0;
        return;
      }

      const currentSelection = this.preQualifiedDynamicTable.selectedFilters[field] || [];
      const validSelection = currentSelection.filter(value => availableValues.includes(value));

      this.preQualifiedDynamicTable.checkedFilters[field] = [...validSelection];
      this.preQualifiedDynamicTable.selectedFilters[field] = [...validSelection];
      this.preQualifiedDynamicTable.selectAllFilters[field] =
        availableValues.length > 0 && validSelection.length === availableValues.length;
    });

    this.preQualifiedDynamicTable.filterHierarchy = [...this.prescreenedFilterHier];
  }

  /* Clear Study Column */
  clearGridColumn(event, table, colname) {
    this.isClearPrescreenedFilterOn = true;
    switch (colname) {
      case "studyName":
        this.prescreenedFilter.studyNumber = [];
        this.checkedStudyName = []
        break;
      case "age":
        this.prescreenedFilter.age = [];
        this.checkedAge = []
        break;
      case "gender":
        this.prescreenedFilter.gender = [];
        this.checkedGender = []
        break;
      case "createdDate":
        this.prescreenedFilter.dateCreated = [];
        this.checkedDateCompleted = []
        break;
    }
    this.prescreenedFilterHier = this.prescreenedFilterHier.filter(x => x !== colname);

    this.clearPrescreenFilter(colname);
    table.filter('', colname, 'contains');
    this.userPreferencesStore.setPreScreenedLibraryFilter(this.prescreenedFilter);
  }
  getPreScreenedApplicants() {
    if (this.prescreenedFilter.age.includes(0) && !this.prescreenedFilter.age.includes(null))
      this.prescreenedFilter.age.push(null);

    this.participantService.getPrescreenedApplicants(this.prescreenedFilter)
      .subscribe(response => {
        this.participantlist = response;
        this.filteredParticipantlist = response;
       this.filteredParticipantlist.forEach(x => { 
            x.createdDate = x.createdDate !== null 
            ? this.datePipe.transform(x.createdDate, DateHelper.dateFormat) 
            : x.createdDate; 
            });
        this.getFilters("", "");
      });
  }

  filterGridRecords(event, table, colname) {
    if (!this.prescreenedFilterHier.includes(colname))
      this.prescreenedFilterHier.push(colname);

    if (event !== null) {
      this.isFromSessionStore = false;
    }

    switch (colname) {
      case "studyName":
        this.clearStudy.forEach(ds => {
          this.prescreenedFilter.studyNumber = ds.value;
          ds.overlayVisible = false;
        });
        break;
      case "age":
        this.clearage.forEach(ds => {
          this.prescreenedFilter.age = ds.value;
          ds.overlayVisible = false;
        });
        break;
      case "gender":
        this.cleargender.forEach(ds => {
          this.prescreenedFilter.gender = ds.value;
          ds.overlayVisible = false;
        });
        break;
      case "createdDate":
        this.cleardateCompleted.forEach(ds => {
          this.prescreenedFilter.dateCreated = ds.value;
          ds.overlayVisible = false;
        });
        break;
    }
    if (this.prescreenedFilter.age.includes(0) && !this.prescreenedFilter.age.includes(null))
      this.prescreenedFilter.age.push(null);

    this.userPreferencesStore.setPreScreenedLibraryFilter(this.prescreenedFilter);
    this.participantService.getPrescreenedApplicants(this.prescreenedFilter)
      .subscribe(response => {
        this.participantlist = response;
        this.filteredParticipantlist = response;
        this.getFilters(colname, "ok");
      });
  }
  clearPrescreenFilter(colname) {
    if (this.prescreenedFilter.age.includes(0) && !this.prescreenedFilter.age.includes(null))
      this.prescreenedFilter.age.push(null);

    this.participantService.getPrescreenedApplicants(this.prescreenedFilter)
      .subscribe(response => {
        this.participantlist = response;
        this.filteredParticipantlist = response;
        this.getFilters(colname, "clear");
      });
  }

  filterApplicants(filterFor) {
    for (let key in this.filteredParticipantlist) {
      if (this.filteredParticipantlist.hasOwnProperty(key)) {
        this.filteredParticipantlist[key].name = this.filteredParticipantlist[key].lastName + ", " + this.filteredParticipantlist[key].firstName;
        this.filteredParticipantlist[key].gender = this.filteredParticipantlist[key].gender === "M" ? "Male" : this.filteredParticipantlist[key].gender === "F" ? "Female" : this.filteredParticipantlist[key].gender;
        this.filteredParticipantlist[key].age = this.filteredParticipantlist[key].age === null ? 0 : this.filteredParticipantlist[key].age;
        this.filteredParticipantlist[key].createdDate = this.filteredParticipantlist[key].createdDate === null ? "" : this.filteredParticipantlist[key].createdDate;
      }
    }

    if (!this.isClearPrescreenedFilterOn) {
      Promise.resolve().then(() => {
        if (this.isFromSessionStore) {
          this.checkedStudyName = this.selectedStudyName;
          this.checkedAge = this.selectedAge;
          this.checkedGender = this.selectedGender;
          this.checkedDateCompleted = this.selectedDateCompleted;
        } else {
          if (this.isFirstVisit || this.sessionStorePrescreened === null) {
            this.checkedStudyName = this.filteredParticipantlist.map(x => x.studyName)
              .filter((value, index, self) => self.indexOf(value) === index);
            this.checkedAge = this.filteredParticipantlist.map(x => x.age)
              .filter((value, index, self) => self.indexOf(value) === index);
            this.checkedGender = this.gender.map(x => x.value);
            this.checkedDateCompleted = this.filteredParticipantlist.map(x => (this.datePipe.transform(x.createdDate, 'dd MMM yyyy')))
              .filter((value, index, self) => self.indexOf(value) === index);
          } else {
            this.checkedStudyName = this.prescreenedFilter.studyNumber;
            this.checkedAge = this.prescreenedFilter.age;
            this.checkedGender = this.prescreenedFilter.gender;
            this.checkedDateCompleted = this.prescreenedFilter.dateCreated;
          }
        }
        this.isFirstVisit = false;
        this.isClearPrescreenedFilterOn = false;
        this.cdr.markForCheck();
      });
      return;
    }
    this.isFirstVisit = false;
    this.isClearPrescreenedFilterOn = false;
  }
  paginate(event) {
    if (this.scrollTop && this.scrollTop.nativeElement) {
      this.scrollTop.nativeElement.focus();
    }
  }


  exportStudyData(studyDetails) {
    this.participantService.getParticipantListForExport(studyDetails.studyId, this.httpClientRequestTimeOut).subscribe(
      (response: any) => {
        let data = response.Participants;       
        let customHeader = response.CustomHeader || 'Other'; // Fallback to 'Other'
        this.participantListForExport = [];

        if (data?.length) {
          data.forEach(par => {
            let consentParts = [];
            if (par.AllowPhone) consentParts.push('Phone');
            if (par.AllowEmail) consentParts.push('Email');
            if (par.AllowMessage) consentParts.push('SMS');
            let participantDetail = {
              'First Name': par.FirstName,
              'Last Name': par.LastName,
              'Email Id': par.EmailId,
              'Phone': par.Phone,
              'DOB': par.DateofBirth,
              'Gender at Birth': par.Gender === 'M' ? 'Male' : 'Female',
              get Age() {
                let age = new Date().getFullYear() - new Date(this.DOB).getFullYear();
                const monthDifference = new Date().getMonth() - new Date(this.DOB).getMonth();
                if (monthDifference < 0 || (monthDifference === 0 && new Date().getDate() < new Date(this.DOB).getDate())) {
                  age--;
                }
                return age;
              },
              'When to Call': par.WhenToCall,
              'Consent to Contact': consentParts.join(',') || '',
              'Attempt Date': par.CreatedDate,
              'Attempts': par.AttemptCount,
              'Latest Attempt': par.LatestAttempt,
              'Status': par.UserStatus,
              'Admin ID': '',
              'Height (Total Inches)': par.Height,
              'Weight': par.Weight,
              'BMI': par.Bmi,
              'Upper Arm Circumference (inches)': par.UpperArmCircumference,
              'Waist Circumference (inches)': par.WaistCircumference,
              'Wrist Circumference (inches)': par.WristCircumference,
              'Fasting Blood Sugar': par.FastingBloodSugar,
              'A1C within the last 6 months': par.A1Cwithinthelast6months,
              'AHI Score from Sleep ': par.AHIScorefromSleepStudy,
              [customHeader]: par.Other
            };

            for (let key in par.QuestionsAndAnswers) {
              if (par.QuestionsAndAnswers.hasOwnProperty(key)) {
                participantDetail[`${key}`] = par.QuestionsAndAnswers[key] === null ? 'NA' : `${par.QuestionsAndAnswers[key]}`;
              }
            }
            this.participantListForExport.push(participantDetail);
          });

          const studyStatus = this.getStatusName(studyDetails.StatusId) ?? 'Unknown';
          setTimeout(() => {
            this.exportExcel.exportStudyAsExcelFile(this.participantListForExport, "Study Details", studyDetails, studyStatus);
          }, 2000);
        } else {
          alert('No Participant found for this Study.');
        }
      },
      error => console.error('Error fetching study details', error)
    );
    this.participantListForExport = [];
  }

  onRowSelect() {
    this.updateDeleteButtonState();
  }

  onRowUnselect() {
    this.updateDeleteButtonState();
  }

  isStudySelected(study: studyModel): boolean {
    return this.selectedStudies.some(selected => selected.studyId === study.studyId);
  }

  isAllStudiesSelected(): boolean {
    return !!this.filterAvailablestudies?.length && this.selectedStudies.length === this.filterAvailablestudies.length;
  }

  isSomeStudiesSelected(): boolean {
    return this.selectedStudies.length > 0 && !this.isAllStudiesSelected();
  }

  isFilterAllSelected(selectedValues: any[] | null | undefined, options: SelectItem[] | null | undefined): boolean {
    if (!options || options.length === 0) {
      return false;
    }
    if (!selectedValues || selectedValues.length === 0) {
      return false;
    }

    const optionValues = options.map(option => option.value);
    return optionValues.every(value => selectedValues.includes(value));
  }

  isFilterSomeSelected(selectedValues: any[] | null | undefined, options: SelectItem[] | null | undefined): boolean {
    if (!options || options.length === 0 || !selectedValues || selectedValues.length === 0) {
      return false;
    }

    return !this.isFilterAllSelected(selectedValues, options);
  }

  toggleFilterSelectAll(checked: boolean, target: string, options: SelectItem[] | null | undefined, multiSelect?: MultiSelect): void {
    const allValues = checked && options ? options.map(option => option.value) : [];

    switch (target) {
      case 'checkedStudyNumber':
        this.checkedStudyNumber = allValues as string[];
        break;
      case 'checkedStudyTags':
        this.checkedStudyTags = allValues as string[];
        break;
      case 'checkedStudyStatus':
        this.checkedStudyStatus = allValues as string[];
        break;
      case 'checkedStudyName':
        this.checkedStudyName = allValues as string[];
        break;
      case 'checkedAge':
        this.checkedAge = allValues as number[];
        break;
      case 'checkedGender':
        this.checkedGender = allValues as string[];
        break;
      case 'checkedDateCompleted':
        this.checkedDateCompleted = allValues as string[];
        break;
    }

    if (multiSelect) {
      multiSelect.updateModel([...allValues]);
      this.cdr.detectChanges();
    }
  }

  toggleStudySelection(study: studyModel, checked: boolean): void {
    if (checked) {
      if (!this.isStudySelected(study)) {
        this.selectedStudies = [...this.selectedStudies, study];
      }
    } else {
      this.selectedStudies = this.selectedStudies.filter(selected => selected.studyId !== study.studyId);
    }
    this.updateDeleteButtonState();
  }

  toggleAllStudies(checked: boolean): void {
    this.selectedStudies = checked ? [...this.filterAvailablestudies] : [];
    this.updateDeleteButtonState();
  }

  updateDeleteButtonState() {
    const hasArchivedSelection = this.selectedStudies.some(study => study.StatusId === StudyStatus.Archive);
    this.deferUiUpdate(() => {
      this.isDeleteEnabled = hasArchivedSelection;
    });
  }

  deleteSelectedStudies() {
    const archivedStudyIds = this.selectedStudies.filter(stu => stu.StatusId === StudyStatus.Archive).map(s => s.studyId).join(',');
    this.studyService.deleteArchievedStudies(archivedStudyIds).subscribe(res => {
      this.isDeleteApplied = true;
      this.getAvailableStudies();
      this.selectedStudies = [];
      this.updateDeleteButtonState();
      this.confirmationService.close();
      alert("Your selection(s) have been deleted");
    });
  }

  confirmDelete() {
    const archivedStudies = this.selectedStudies.filter(st => st.StatusId === StudyStatus.Archive).map(s => s.studyName).join(', ');
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ' + archivedStudies + '?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteSelectedStudies();
      },
      reject: () => {
        this.updateDeleteButtonState();
        this.confirmationService.close();
      }
    });
  }

  exportAsXLSX() {
    const defaultPrescreenedFilter: filterPrescreened = new filterPrescreened();
    this.participantService.getPrescreenedApplicants(defaultPrescreenedFilter)
      .subscribe(response => {
        if (response?.length) {
          response.forEach(par => {
            const consentParts = [];
            if (par.allowPhone) consentParts.push('Phone');
            if (par.allowEmail) consentParts.push('Email');
            if (par.allowMessage) consentParts.push('SMS');
            const preQualifiedApplicant = {
              'First Name': par.firstName,
              'Last Name': par.lastName,
              'Study Number': par.studyName,
              'Age': par.age,
              'Gender': par.gender,
              'Created Date': par.createdDate,
              'Consent to Contact': consentParts.join(',') || '',
              'Phone Number': par.phone,
              'Email ID': par.emailId,
              'When to call': par.WhentoCall,
              'Admin ID': par.adminId
            }
            this.preQualifiedListForExport.push(preQualifiedApplicant);
          });
        }
        setTimeout(() => {
          this.exportExcel.exportAsExcelFile(this.preQualifiedListForExport, 'PreQualified-Applicants');
          this.preQualifiedListForExport = [];
        }, 1000);
      });
  }
}
